import { render } from "./ThankyouView.vue?vue&type=template&id=51fe7d3c"
import script from "./ThankyouView.vue?vue&type=script&lang=js"
export * from "./ThankyouView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__